<template>
  <b-container fluid>
    <b-form @submit="getData" class="mb-3">
      <b-form-row class="my-1">
        <b-col>
          <label>Part Num (exact search only)</label>
          <b-form-input type="text" v-model="num" />
        </b-col>
        <b-col>
          <label>Start Date</label>
          <b-form-input type="date" v-model="startDate" />
        </b-col>
        <b-col>
          <label>End Date</label>
          <b-form-input type="date" v-model="endDate" />
        </b-col>
      </b-form-row>
      <b-form-row class="my-1">
        <b-btn type="submit">Search</b-btn>
      </b-form-row>
    </b-form>
    <b-row v-if="items.count > 0">
      <b-col>
        Total Cost: {{cost | formatDollars}}
      </b-col>
      <b-col>
        Total Price: {{price | formatDollars}}
      </b-col>
      <b-col>
        Total Revenue {{revenue | formatDollars}}
      </b-col>
      <b-col>
        Total Sold {{sold.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
      </b-col>
    </b-row>
    <b-row v-if="loading" class="justify-content-md-center">
      <fingerprint-spinner
        :animation-duration="1500"
        :size="300"
        color="#293a93"
        class="my-3"
      />
    </b-row>
    <b-row v-else-if="noneFound" class="justify-content-md-center">
      No Data Found... Have we sold that item or items its in during your date range?
    </b-row>
    <b-row v-else>
      <b-col>
        <div class="text-center">
          This assumes this part was in stock throughout the entire date range
        </div>
        <div class="text-center">
          Whats all this mean?
          <b-button size="sm" variant='link' v-b-modal.info-modal class="px-0">
            <i class="fas fa-question-circle"></i>
          </b-button>
        </div>
        <b-table :items="items" :fields="columns">
          <template slot="total_cost" slot-scope="data">
            {{data.item.total_cost | formatDollars}}
          </template>
          <template slot="total_price" slot-scope="data">
            {{data.item.total_price | formatDollars}}
          </template>
          <template slot="total_revenue" slot-scope="data">
            {{data.item.total_revenue | formatDollars}}
          </template>
          <template slot="total_sold" slot-scope="data">
            {{data.item.total_sold}}
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-modal id='info-modal' centered scrollable hide-footer size="lg" title="More Info">
      <div>
        <strong>Month/Year</strong>
        <p>The relevant timespan for the below data</p>
      </div>
      <div>
        <strong>Cost</strong>
        <p>The total cost of <em>this item</em> over the timespan</p>
      </div>
      <div>
        <strong>Price</strong>
        <p>The total price of this item <em>and every item its sold in</em> over the timespan</p>
      </div>
      <div>
        <strong>Revenue</strong>
        <p>The above <strong>Price</strong> minus the above <strong>Cost</strong> over the timespan</p>
      </div>
      <div>
        <strong>Total Sold</strong>
        <p>The total number of this item that left the building (including in other items) over the timespan</p>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import { FingerprintSpinner } from 'epic-spinners';
import { mapActions, mapGetters } from 'vuex';
const BASE_API = process.env.VUE_API_ROOT;

export default {
  data() {
    return {
      num: '',
      startDate: null,
      endDate: null,
      loading: false,
      noneFound: false,
      columns: [
        {key: 'ref', label: 'Month/Year'},
        {key: 'total_cost' , label: 'Cost'},
        {key: 'total_price', label: 'Price'},
        {key: 'total_revenue', label: 'Revenue'},
        {key: 'total_sold'},
      ],
      items: [],
      cost: 0,
      price: 0,
      revenue: 0,
      sold: 0,
    };
  },
  components: {
    FingerprintSpinner,
  },
  methods: {
    getData(event) {
      if (event) event.preventDefault()
      if (this.num == '') return;

      this.loading = true;
      this.noneFound = false;
      this.items.splice(0)

      let start = (this.startDate == null ? moment("2010-01-01") : moment(`${this.startDate}`)).format('YYYY-MM-DDTHH:mm:ssZ');
      let end = (this.endDate == null ? moment() : moment(`${this.endDate}`)).format('YYYY-MM-DDTHH:mm:ssZ');

      axios.get(`${BASE_API}/am-old-db/part-info/part-evaluator/${this.num}/${start}/${end}`).then(response => {
        this.items = response.data;

        if (this.items.length === 0) {
          this.noneFound = true;
          return;
        }
        this.items.forEach( item => {
          item.ref = moment({ year: item.year, month: item.month - 1 }).format("MMMM YYYY")
        });
        this.cost = this.items.map(x => Number(x.total_cost)).reduce((a, b) => a + b);
        this.price = this.items.map(x => Number(x.total_price)).reduce((a, b) => a + b);
        this.revenue = this.price - this.cost;
        this.sold = this.items.map(x => Number(x.total_sold)).reduce((a, b) => a + b);
      }).catch(error => {
        console.error(error);
      }).finally(() => {
        this.loading = false;
      });
    }
  },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/inventory/PartEvaluator.vue